import { api } from "../axiosConfig";
import { store } from "../store";
import { notifyService } from "./notifyService";

export async function addProperty(data) {
  return await api
    .post("/properties/addProperty", data, { headers: { "Authorization" : `Bearer ${store.getState().auth.value.accessToken }`}})
    .then((res) => {
      notifyService(res.data)
    })
    .catch((err) => console.log(err));
}
